import React from 'react';
import cn from 'classnames';
import styles from './Spinner.module.scss';

interface OwnProps {
  className?: string;
}

const Spinner = ({ className }: OwnProps) => (
  <div className={cn(styles.skChase, className)}>
    <div className={styles.skChaseDot} />
    <div className={styles.skChaseDot} />
    <div className={styles.skChaseDot} />
    <div className={styles.skChaseDot} />
    <div className={styles.skChaseDot} />
    <div className={styles.skChaseDot} />
    <div className={styles.skChaseDot} />
  </div>
);

export default Spinner;
